// extracted by mini-css-extract-plugin
module.exports = {"icon_box":"FJLoading_icon_box__gv4ty","icon_box_show":"FJLoading_icon_box_show__RYi43"};